var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"Component",staticClass:"badge"},[_c('div',{class:_vm.icon}),_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }